import { Navbar } from "react-bootstrap";
import AboutUsHero from "../../components/AboutUs/AboutUsHero";
import OurMission from "../../components/AboutUs/OurMission";
import OurVision from "../../components/AboutUs/OurVision";
import MeetOurTeam from "../../components/AboutUs/TeamMember";
import Footer from "../../components/Footer/Footer";

function AboutUs() {
  return (
    <div className="Landing-page-all">
      <Navbar />
      <AboutUsHero />
      <OurMission />
      <OurVision />
      <MeetOurTeam />
      <Footer />
    </div>
  );
}

export default AboutUs;
